import React from 'react';



import { Link } from "react-router-dom";
//import '../App.css';


import tabla from 'assets/img/tabla.png';
import config from 'assets/img/config.png';
import pdficon from 'assets/img/pdficon.png';
import inscrip from 'assets/img/inscrip.png';
import listac from 'assets/img/listac.png';


const Panel = () => {
    return (
      <div >

        <div className="container pt-4">

          <h4 style={{ color: "grey" }}><i className="fa fa-hand-up"></i>Panel de control</h4>

          <div className="row">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

              <div className="box box-default">
                <div className="box-header with-border">
                  <h4 className="box-title">Tablas</h4>
                </div>

                <div className="box-body">

                  <div className="itemx">
                    <Link to="/materialist" className="itemText link" >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Tabla materia
                    </Link>
                  </div>

                  {/*<div className="itemx">
                    <Link to="/categorialist" className="itemText link" >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Tabla Categoría
                    </Link>
                  </div>*/}

                  <div className="itemx">
                    <Link to="/carreralist" className="itemText link" >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Tabla Carrera
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link to="/docentelist" className="itemText link" >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Tabla docente
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link to="/estudiantelist" className="itemText link" >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Tabla estudiante
                    </Link>
                  </div>





                </div>
                {/* ---  /.box-body ---*/}

              </div>

              <div className="box box-success">
                <div className="box-header with-border">
                  <h3 className="box-title">Asignaciones</h3>
                </div>

                <div className="box-body">
                  {/* --- itemx ---*/}
                  {/* --- <div className="itemx">
                    <a id="btn_01" className="itemImage iconx bg-icon02" href="http://plavirbol.nubox8.com/examen/public/docente_materia_crud_index"></a>
                    <a id="btn_02" className="itemText link" href="http://plavirbol.nubox8.com/examen/public/docente_materia_crud_index" >Docente - materia</a>
                  </div>---*/}


                  <div className="itemx">
                    <Link to="/docente_materialist" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Asignar materias a docentes
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link to="/materia_docentelist" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Asignar materias libres a docentes
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link to="/prograbuscarci" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Programación de materias
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link to="/importarestxmateria" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Importar estudiantes x materia
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link to="/importarest" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Importar estudiantes
                    </Link>
                  </div>


                  <div className="itemx">
                    <Link to="/pass_resta_doc" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Restablecer contraseña Docente
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link to="/pass_resta_est" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Restablecer contraseña Estudiante
                    </Link>
                  </div>


                </div>
                {/* ---  /.box-body ---*/}

              </div>

              <div className="box box-success">
                <div className="box-header with-border">
                  <h3 className="box-title">Otros </h3>
                </div>

                <div className="box-body">
                  {/* --- itemx ---*/}
                  
                  <div className="itemx">
                    <Link to="/hab_llenado_notas" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Habilitar llenado de notas
                    </Link>
                  </div>
                  {/*  
                  <div className="itemx">
                    <a className="itemImage iconx bg-icon02" href="http://plavirbol.nubox8.com/examen/public/horariov2_index"></a>
                    <a className="itemText link" href="http://plavirbol.nubox8.com/examen/public/horariov2_index"> Asignación de horarios</a>
                  </div>

                  <div className="itemx">
                    <a className="itemImage iconx bg-icon02" href="http://plavirbol.nubox8.com/examen/public/programacion_edit"></a>
                    <a className="itemText link" href="http://plavirbol.nubox8.com/examen/public/programacion_edit"> Programación editar</a>
                  </div>
                    */}
                  <div className="itemx">
                    <Link to="/progra_list" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Lista de programacion por curso
                    </Link>
                  </div>
                  

                  <div className="itemx">
                    <Link to="/progra_cambia_grupo" className="itemText " >
                      <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                      Programación cambiar grupo
                    </Link>
                  </div>




                </div>
                {/* ---  /.box-body ---*/}

              </div>
              <div className="box box-success">
                <div className="box-header with-border">
                  <h3 className="box-title">Reportes</h3>
                </div>

                <div className="box-body">
                  {/* --- itemx ---*/}
                  <div className="itemx">
                    <Link className="itemText link" to="/rep_mate_x_carrera">
                      <img src={pdficon} height="35" align="left" alt="" className='itemImage' />
                      Lista de materias por carrera
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link className="itemText link" to="/rep_est_x_materia">
                      <img src={pdficon} height="35" align="left" alt="" className='itemImage' />
                      Lista de estudiantes por materia
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link className="itemText link" to="/rep_mate_x_docente">
                      <img src={pdficon} height="35" align="left" alt="" className='itemImage' />
                      Lista de materias por docente
                    </Link>
                  </div>


                  <div className="itemx">
                    <Link className="itemText link" to="/cert_notas">
                      <img src={pdficon} height="35" align="left" alt="" className='itemImage' />
                      Boletin de calificaciones
                    </Link>
                  </div>

                  <div className="itemx">
                    <Link className="itemText link" to="/historial_acad">
                      <img src={pdficon} height="35" align="left" alt="" className='itemImage' />
                      Historial académico
                    </Link>
                  </div>
                    {/*
                  <div className="itemx">
                    <a className="itemImage iconx bg-icon02" href="http://plavirbol.nubox8.com/examen/public/programacion_crud" aria-label="c"></a>
                    <a className="itemText link" href="http://plavirbol.nubox8.com/examen/public/programacion_crud">Lista materias y programaciones</a>
                  </div>
                    */}


                </div>
                <br />
                {/* ---  /.box-body ---*/}
                <div className="box box-success">
                  <div className="box-header with-border">
                    <h3 className="box-title">Preinscripciones</h3>
                  </div>

                  <div className="box-body">


                    <div className="itemx">
                      <Link to="/hab_preins_carrera" className="itemText " >
                        <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                        Establecer materias para preinscripción
                      </Link>
                    </div>

                    <div className="itemx">
                      <Link to="/habilitar_preinslist" className="itemText " >
                        <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                        Habilitar a preinscitos
                      </Link>
                    </div>

                    <div className="itemx">
                      <Link to="/inscripcion" className="itemText " >
                        <img src={listac} height="35" align="left" alt="" className='itemImage' />
                        Inscripción de estuditantes
                      </Link>
                    </div>

                    <div className="itemx">
                      <Link to="/inscribir_est_x_ci" className="itemText " >
                        <img src={listac} height="35" align="left" alt="" className='itemImage' />
                        Inscripción de estuditantes por C.I.
                      </Link>
                    </div>
                     {/* 
                    <div className="itemx">
                      <a className="itemImage iconx bg-icon02" href="http://plavirbol.nubox8.com/examen/public/estudiante_preins_v1_buscar"></a>
                      <a className="itemText link" href="http://plavirbol.nubox8.com/examen/public/estudiante_preins_v1_buscar">Eliminar preinscripción</a>
                    </div>
                    */}
                  </div>
                </div>
                {/* ---  /.box-body ---*/}
                <div className="box box-success">
                  <div className="box-header with-border">
                    <h3 className="box-title">Super admin</h3>
                  </div>

                  <div className="box-body">
                    <div className="itemx">
                      <Link to="/globalx" className="itemText " >
                        <img src={config} height="35" align="left" alt="" className='itemImage' />
                        Configuración
                      </Link>
                    </div>


                    <div className="itemx">
                      <Link to="/usuarios" className="itemText " >
                        <img src={tabla} height="35" align="left" alt="" className='itemImage' />
                        Crear usuario
                      </Link>
                    </div>


                  </div>
                </div>




              </div>





            </div>



          </div>




        </div>
      </div>
    );
}

export default Panel;